export const SHIFT_DETAILS_FOOTER_LOG_EVENT_SOURCE_UI = "shift-details-footer";

export const SKIP_WORKPLACE_SIGNATURE_QUERY_PARAM_KEY = "skipWorkplaceSignature";
